import { Button } from "@/components/ui/button";

import type { ClaimWithRelations } from "../../api/use-claim";
import { useLegalSubpoena } from "../../api/use-claim-actions";
import { ClaimDocuments } from "../claim-documents";
import { CtaShell } from "./cta-shell";
import { GenerateLegalSubpoena } from "./generate-legal-subpoena";

/** Hardcoded exhibits order — mirrors LegalSubpeonaCTA.vue / InitProcedureCTA.vue. */
export function ExhibitsOrderPre() {
  return (
    <pre className="prose overflow-x-auto py-4 text-xs">
      {`
Pièce n°1: \tExtrait K-bis de la société UPCLAIM
Pièce n°2: \tExtrait K-bis de la société [AIRLINE_NAME]
Pièce n°3: \tRéservation confirmée
Pièce n°4: \tCession de créances entre le Passager - JANCARTHIER
Pièce n°5: \tCession de créances JANCARTHIER – UPCLAIM
Pièce n°6: \tEmail de la société UPCLAIM à la société [AIRLINE_NAME]
Pièce n°7: \tCourrier de mise en demeure de la société UPCLAIM
Pièce n°8: \tPièces justificatives
Pièce n°9: \tPièces justificatives
`}
    </pre>
  );
}

/** Port of states-cta/LegalSubpeonaCTA.vue — préparation du projet d'assignation. */
export function LegalSubpoenaCTA({ claim }: { claim: ClaimWithRelations }) {
  const { data: legalSubpoena, isPending } = useLegalSubpoena(claim.id);

  return (
    <CtaShell legalStepName={claim.claimLegalStep.name}>
      <p className="mt-4 text-sm leading-6 text-gray-500">
        <span className="leading-8 font-semibold text-gray-900">
          Préparer le Projet d'Assignation
          <br />
        </span>
        <span className="font-semibold text-slate-600">
          Bien vérifier les demandes (Article 5, 9, 14.2, et demandes supplémentaires).
        </span>
      </p>

      <ExhibitsOrderPre />

      {!isPending ? (
        <div className="py-6">
          {!legalSubpoena?.legalSubpoenaPdfFileId ? (
            <div className="relative block py-4 text-sm">
              <GenerateLegalSubpoena claim={claim} legalSubpoena={legalSubpoena ?? null} />
              <div className="mt-4">
                <ClaimDocuments claim={claim} />
              </div>
            </div>
          ) : (
            <div className="rounded-md bg-green-50 p-4 text-sm">
              <p className="font-medium text-green-800">Projet d'assignation détecté</p>
              <p className="mt-1 text-green-700">Il faut maintenant la transmettre à l'huissier.</p>
              <div className="mt-4">
                <Button variant="outline">Assignation transmise à l'huissier</Button>
              </div>
            </div>
          )}
        </div>
      ) : null}
    </CtaShell>
  );
}
